const MENUS_BY_VERSION_V1 = [
  'prGroup',
  'socialMediaGroup',
  'mmGroup',
  'liveStreamingGroup',
  'brandCreativityGroup',
  'overseasComprehensiveGroup',
  'esportsGroup',
  'flowDistributionGroup',
  'smFlowAuditor',
  'report',
  // 'management',
];
// 切换旧版路径
export function matchV1PathByRouter(targetHashPath = '') {
  // @ts-ignore
  if (window.$checkOld === false) return ''
  const hash = targetHashPath || window.location.hash || '';
  const rootHashPath = hash.split('/')[1]?.toLowerCase?.();
  const isV1Path = MENUS_BY_VERSION_V1.map((item) => item.toLowerCase()).includes(rootHashPath);
  let targetPathName = '';
  if(isV1Path && !location.pathname.startsWith('/old')) {
    targetPathName = '/old';
  }

  if (!isV1Path && location.pathname.startsWith('/old')) {
    targetPathName = '/';
  }
  return targetPathName;
}


type OpenTarget = '_self' | '_blank';
// 处理旧版路由跳转
export function checkV1Router(targetHashPath = '', openTarget?: OpenTarget) {
  let hashPath = targetHashPath || window.location.hash || '';
  if (!hashPath.startsWith('#')) {
    hashPath = `#${targetHashPath}`;
  }
  if (!hashPath.startsWith('#/')) {
    hashPath = `#/${targetHashPath}`;
  }
  const targetPathName = matchV1PathByRouter(hashPath);
  if (targetPathName) {
    // 新建地址对象，修改pathName和hash
    const newLocationObj = new URL(window.location.href);
    newLocationObj.pathname = targetPathName;
    newLocationObj.hash = hashPath;
    if (!openTarget) {
      return newLocationObj.toString();
    }
    window.open(newLocationObj.toString(), openTarget);
    return true
  }
  return false
}

// 监听hash变化
window.addEventListener('hashchange', () => {
  let targetPathName = matchV1PathByRouter();
  if (targetPathName) {
    location.pathname = targetPathName;
  }
});

function initV1Check() {
  try {
    checkV1Router(window.location.hash, '_self');
  } catch (error) {
    console.error('initV1Check error:', error);
  }
}

// 初始化
initV1Check();
